
module.exports = { 
      attributes: {},
    
      body: "# WAPHA Commissioned Services Support\n\n<br />\n\nIf you have difficulty locating a particular service, would like assistance with this site, or have suggestions, please complete the support request below and our support staff will be happy to assist.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/wqphn/content/static/default/support.md"},
     }